window.Shopify.currency = {
  ...window.Shopify.currency,
  lengthUnit: '"',
  lengthRate: 1
};
if (window.Shopify.routes.root == '/') {
  window.Shopify.currency = {
    ...window.Shopify.currency,
    icon: '$',
    lengthUnit: '"',
    lengthRate: 1
  };
}

function matchNum (str = '') {
  const match = str.toString().match(/\d+/); // 匹配连续数字
  if (match) {
    var text = parseInt(match[0], 10) || 0;
    return text;
  }
}

// 判断字符串是否为数字
function isNumeric(str) {
  return !isNaN(parseFloat(str)) && isFinite(str.trim());
}

function chatOpen () {
  if (window.tidioChatApi) {
    window.tidioChatApi.show();
    window.tidioChatApi.open();
  }
}

var topEvent = scrollTop > 0 ? ["header.header"] : ["header.header", ".countdown-timer-bar"];
// 页面滚动使指定元素置顶
function windowScrollTop (event, topEventList = [], fevent = "html,body") {
  topEvent = scrollTop > 0 ? ["header.header"] : ["header.header", ".countdown-timer-bar"];
  if (topEventList.length == 0) {
    topEventList = topEvent;
  }
  var item = event,
    headerHeight = 0;
  const itemScrollTop = item.offset().top;
  for (var i = 0; i < topEventList.length; i++) {
    headerHeight += parseInt($(topEventList[i]).outerHeight() || 0);
  }
  const feventScrollTop = fevent == "html,body" ? 0 : $(fevent).scrollTop();
  $(fevent).animate(
    {
      scrollTop: Math.floor(
        itemScrollTop - headerHeight - $(fevent).offset().top + feventScrollTop
      ),
    },
    150
  );
}

function windowScrollHeight () {
  return getComputedStyle(document.documentElement).getPropertyValue('--header-height');
}

// 防抖函数
function debounce (func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
}

// 节流函数
function throttle (func, limit) {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this,
      args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

// 计算最接近值
function findClosestSize(sizeData, inputWidth, inputHeight) {
  let closest = null;
  let minDiff = Infinity;

  // 遍历所有尺寸
  for (const [sizeStr, price] of Object.entries(sizeData)) {
    const [w, h] = sizeStr.split('x').map(Number);
    
    // 检查是否满足尺寸条件
    if (w >= inputWidth && h >= inputHeight) {
      // 计算尺寸差异（欧氏距离）
      const diff = Math.sqrt(
        Math.pow(w - inputWidth, 2) + 
        Math.pow(h - inputHeight, 2)
      );
      
      // 更新最接近的尺寸
      if (diff < minDiff) {
        minDiff = diff;
        closest = { size: sizeStr, price };
      }
    }
  }
  return closest;
}

function coverageSize(params, sizeRange = product.metafields.custom.size_range) {
  const matchUnitList = matchUnit(params);
  // 连接符
  const connector = matchUnitList.connector;
  // 单位
  const unit = matchUnitList.unit;

  // 根据连接符分割数组
  const arr = params.split(connector);
  // 保存数字部分
  var sizeArr = [];
  $.each(arr, (i, item) => {
    sizeArr.push(matchNum(item));
  });
  // 计算范围
  if (sizeRange.length > 0 && sizeArr.length > 0) {
    var list = [];
    $.each(sizeArr, (i, size) => {
      if (sizeRange[i + 1] > 0) {
        list.push(`${Math.round(size * sizeRange[i])}${unit} - ${Math.round(size * sizeRange[i + 1])}${unit}`);
      } else {
        list.push(`${size}${unit}`);
      }
    });
    return list;
  }
}

function matchUnit(params) {
  const connector = params.includes('x') ? 'x' : '*';
  // 转义特殊字符（如*需要转义为\*）
  const escapedConnector = connector.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // 动态构建正则表达式（适配带/不带W/L前缀的情况）
  const regex = new RegExp(
      `(?:W|L)?(\\d+)([^x*]+)${escapedConnector}\\s*(?:W|L)?(\\d+)([^x*]+)`, 
      'i'
  );
  
  // 匹配示例
  const match = params.match(regex);

  if (match) {
    match[2] = match[2].trim();
    match[2] = isNumeric(match[2]) ? '' : match[2];
    return { "unit": match[2], "connector": connector };
  } else {
    return false;
  }
}